<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-05-23 17:09:56
 * @LastEditTime: 2022-06-09 16:42:43
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <h2>页面自定义内容</h2>
      <div>
        <a-radio-group v-model:value="language" button-style="solid" @change="handleLang">
          <a-radio-button value="zh_CN">中文</a-radio-button>
          <a-radio-button value="en_US">英文</a-radio-button>
        </a-radio-group>
      </div>
      <dc-layout-button-group>
        <a-button type="primary">{{ t('example.edit') }}</a-button>
        <a-button type="primary">{{ t('example.publish') }}</a-button>
        <a-button type="primary">{{ t('example.draft') }}</a-button>
        <a-button type="primary">{{ t('example.delete') }}</a-button>
        <a-button type="primary">{{ t('example.cancel') }}</a-button>
        <a-button type="primary">{{ t('example.confirm') }}</a-button>
      </dc-layout-button-group>

      <div style="height: 50px"></div>

      <h2>antd 组件库内容</h2>
      <a-pagination :total="500" />
      <a-range-picker />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import useLocale from '@/hooks/useLocale'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const { languageToggle } = useLocale()

const language = ref<string>('zh_CN')
const handleLang = () => {
  languageToggle(language.value)
}
</script>
<script lang="ts">
export default { name: 'Example' }
</script>

<style scoped></style>
<!-- <template>
  <dc-layout-main>
    <dc-layout-content>
      <dc-layout-search @search="handleSearch" @reset="handleReset" :loading="loading">
        <a-form ref="formRef" name="advanced_search" :model="formState">
          <dc-form-item name="field0" label="商品状态">
            <a-input v-model:value="formState.field0" placeholder="全部商品状态"></a-input>
          </dc-form-item>
          <dc-form-item name="field1" label="复核状态">
            <a-input v-model:value="formState.field1" placeholder="全部复核状态"></a-input>
          </dc-form-item>
          <dc-form-item name="field2" label="来源">
            <a-select
              v-model:value="formState.field2"
              mode="tags"
              style="width: 100%"
              placeholder="Tags Mode"
              :options="[
                {
                  value: 'DC',
                  label: 'DC'
                },
                {
                  value: 'ARK',
                  label: 'ARK'
                }
              ]"
            ></a-select>
          </dc-form-item>
          <dc-form-item name="field3" label="商品编码（谷仓）">
            <a-input v-model:value="formState.field3" placeholder="请输入商品编码（谷仓）"></a-input>
          </dc-form-item>
          <dc-form-item name="field4" label="客户代码">
            <a-input v-model:value="formState.field4" placeholder="请输入客户代码"></a-input>
          </dc-form-item>
          <dc-form-item name="field5" label="商品名称">
            <a-input-group compact>
              <a-select style="width: 40%">
                <a-select-option value="中文">中文</a-select-option>
                <a-select-option value="英文">英文</a-select-option>
              </a-select>
              <a-input v-model:value="formState.field5" style="width: 60%" />
            </a-input-group>
          </dc-form-item>
          <dc-form-item name="field6" label="申报品名">
            <a-input v-model:value="formState.field6" placeholder="请输入"></a-input>
          </dc-form-item>
          <dc-form-item name="field7" label="时间">
            <a-input-group compact>
              <a-select style="width: 40%">
                <a-select-option value="开始时间">开始时间</a-select-option>
                <a-select-option value="创建时间">创建时间</a-select-option>
              </a-select>
              <a-range-picker
                style="width: 60%"
                :show-time="{ format: 'HH:mm' }"
                format="YYYY-MM-DD HH:mm"
                :placeholder="['Start Time', 'End Time']"
              />
            </a-input-group>
          </dc-form-item>
          <dc-form-item name="field8" label="商品风险等级">
            <a-input v-model:value="formState.field8" placeholder="请选择商品风险等级"></a-input>
          </dc-form-item>
          <dc-form-item name="field9" label="是否需欧代">
            <a-input v-model:value="formState.field9" placeholder="请选择是否需要欧代"></a-input>
          </dc-form-item>
          <dc-form-item name="field10" label="货主ID">
            <a-input v-model:value="formState.field10" placeholder="请输入…"></a-input>
          </dc-form-item>
          <dc-form-item name="field11" label="谷仓品类">
            <a-input v-model:value="formState.field11" placeholder="请选择"></a-input>
          </dc-form-item>
        </a-form>
      </dc-layout-search>
      <dc-layout-button-group>
        <a-button type="primary" @click="handleSync">导出</a-button>
        <a-button type="primary" @click="handleSync">同步</a-button>
        <a-button type="primary" @click="handleAdd">新增</a-button>
        <a-button type="primary" @click="showModal">批量导入</a-button>
      </dc-layout-button-group>
      <a-table
        class="ant-table-striped"
        :dataSource="dataSource"
        :columns="columns"
        :loading="loading"
        size="small"
        :pagination="false"
        :row-class-name="(_record:any, index:number) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'field1'">
            <a href="javascript:;">{{ record.field1 }}</a>
          </template>
          <template v-if="column.key === 'field5'">
            <a href="javascript:;">{{ record.field5 }}</a>
          </template>
          <template v-if="column.key === 'field9'">
            <dc-status :value="record.field9" :enums="customEnum" />
          </template>
          <template v-if="column.key === 'field10'">
            <a-button type="link" @click="handleView">查看</a-button>
            <a-button type="link" @click="handleEdit">编辑</a-button>
          </template>
        </template>
      </a-table>
      <a-pagination
        v-if="needPage"
        v-model:current="page_num"
        :total="total_count"
        @change="handleChangePage"
        :show-total_count="(total_count:number) => `共${total_count}条：`"
      >
        <template #itemRender="{ type, originalElement }">
          <a-button v-if="type === 'prev'">上一页</a-button>
          <a-button v-else-if="type === 'next'">下一页</a-button>
          <component :is="originalElement" v-else></component>
        </template>
      </a-pagination>
    </dc-layout-content>
  </dc-layout-main>

  <a-modal v-model:visible="visible" width="600px" title="批量导入" @ok="handleUpload">
    <div style="padding: 0 40px">
      <a-upload-dragger
        v-model:fileList="fileList"
        name="file"
        :multiple="true"
        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
      >
        <p class="ant-upload-drag-icon">
          <img src="@/assets/example/xslx.svg" alt="" />
        </p>
        <p class="ant-upload-text">将文件直接拖到这里</p>
        <p class="ant-upload-or">或</p>
        <p class="ant-upload-hint">
          <a-button type="primary">选择文件</a-button>
        </p>
      </a-upload-dragger>
      <div style="margin-top: 30px">
        <h3>温馨提示：</h3>
        <p style="margin: 0; color: #666666">1. 模板下载：<a href="javascript:;">商品导入模板.xlsx</a></p>
        <p style="margin: 0; color: #666666">2. 格式限制为 .xlsx 或 .xls</p>
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { ref } from 'vue'
import { DcConfirm, DcMessage } from '@dc-platform/dc-components'
import { layoutTags } from '@dc-platform/dc-interaction'

// type AnyType = number | string | object | boolean | undefined | null
// interface AnyItem {
//   [key: string]: AnyType
// }

export default {
  name: 'DcBaseExample',
  setup() {
    const page_num = ref(1)
    const loading = ref(false)
    const fileList = ref([])
    const visible = ref<boolean>(false)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dataSource: any[] = Array(10)
    const formState = ref({
      field0: '',
      field1: '',
      field2: [],
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      field7: '',
      field8: '',
      field9: '',
      field10: '',
      field11: ''
    })

    dataSource.fill({
      field0: 1,
      field1: 'G1091-202203090006',
      field2: [],
      field3: '商品中文名称',
      field4: 'Cash register display',
      field5: 'G1091',
      field6: 'HeiHei',
      field7: '电脑产品',
      field8: 'M',
      field9: 1
    })

    const handleSync = () => {
      DcConfirm.warning({
        title: '操作提示！',
        content: '本步骤操作提示，可继续进行下一步操作。',
        cancelText: '取消',
        okText: '继续',
        onOk() {
          DcMessage.success('操作成功')
        },
        onCancel() {
          DcMessage.success('操作成功')
        }
      })
    }

    const handleChangePage = () => {
      handleSearch()
    }

    const showModal = () => {
      visible.value = true
    }

    const handleSearch = () => {
      console.log('handlesearch')
      loading.value = true
      setTimeout(() => {
        loading.value = false
      }, 500)
    }

    const handleUpload = () => {
      visible.value = false
      DcMessage.success('上传成功')
      handleSearch()
    }

    const handleReset = () => {
      console.log('handleReset')
      formState.value = {
        field0: '',
        field1: '',
        field2: [],
        field3: '',
        field4: '',
        field5: '',
        field6: '',
        field7: '',
        field8: '',
        field9: '',
        field10: '',
        field11: ''
      }
    }

    const handleAdd = () => {
      layoutTags.goto({
        name: 'DcBaseExampleDetail',
        query: {
          type: 'add'
        }
      })
    }

    const handleView = () => {
      layoutTags.goto({
        name: 'DcBaseExampleDetail',
        query: {
          type: 'view'
        }
      })
    }

    const handleEdit = () => {
      layoutTags.goto({
        name: 'DcBaseExampleDetail',
        query: {
          type: 'edit'
        }
      })
    }

    console.log('dataSource', dataSource)

    return {
      loading,
      handleSearch,
      handleChangePage,
      handleReset,
      handleSync,
      handleAdd,
      handleView,
      handleEdit,
      fileList,
      handleUpload,
      showModal,
      visible,
      needPage: 1,
      page_num,
      total_count: 100,
      number: 10,
      customEnum: [
        {
          value: 1,
          name: '绿灯',
          color: 'green',
          tooltip: '绿灯行'
        },
        {
          value: 2,
          name: '黄灯',
          color: 'yellow',
          tooltip: '黄灯等一等'
        },
        {
          value: 3,
          name: '红灯',
          color: 'red',
          tooltip: '红灯挺'
        }
      ],
      formState,

      dataSource,

      columns: [
        { title: '序号', dataIndex: 'field0', key: 'field0' },
        { title: '商品编码（谷仓）', dataIndex: 'field1', key: 'field1' },
        { title: '来源', dataIndex: 'field2', key: 'field2', sorter: true },
        { title: '商品中文名称', dataIndex: 'field3', key: 'field3' },
        { title: '商品英文名称', dataIndex: 'field4', key: 'field4' },
        { title: '客户代码', dataIndex: 'field5', key: 'field5', sorter: true },
        { title: '商品品牌', dataIndex: 'field6', key: 'field6' },
        { title: '谷仓品类', dataIndex: 'field7', key: 'field7' },
        { title: '货型', dataIndex: 'field8', key: 'field8', sorter: true },
        { title: '商品状态', dataIndex: 'field9', key: 'field9', sorter: true },
        { title: '操作', dataIndex: 'field10', key: 'field10' }
      ]
    }
  }
}
</script> -->
